import { RegionShared } from "@1games-ru/region-shared";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/core/store";

export type ControlSettingsState = typeof RegionShared.Client.Responses.GetBindsResponse;

const initialState: ControlSettingsState = {};

const controlSettingsSlice = createSlice({
  name: "controlSettings",
  initialState,
  reducers: {
    setControlSettings: (state, action: PayloadAction<Partial<ControlSettingsState>>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const controlSettingsSelector = (state: RootState) => state.controlSettings;

export const controlSettingsReducer = controlSettingsSlice.reducer;

export const { setControlSettings } = controlSettingsSlice.actions;
